import React, {useEffect, useState} from 'react';

import {useStore} from 'effector-react';
import {useTranslation} from 'react-i18next';

import {ReactComponent as ClearIcon} from 'assets/svg/cross.svg';
import {Input} from 'components/ui-kit/Input';

import {search$, searchChanged} from 'models/documents/gds';

import {CancelIcon} from './styled';

export const TableSearch = () => {
    const {t} = useTranslation();
    const [isFirstRender, setIsFirstRenter] = useState(true);
    const search = useStore(search$);
    const [value, setValue] = useState(search);
    const delay = 350;
    const handleValueChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue(event.target.value);
    };

    useEffect(() => {
        if (isFirstRender) {
            setIsFirstRenter(false);
            return;
        }
        const timeoutId = setTimeout(() => {
            searchChanged(value);
        }, delay);
        return () => clearTimeout(timeoutId);
    }, [value, delay]);

    return (
        <Input
            value={value}
            onChange={handleValueChange}
            placeholder={t('pages.documents.search')}
            style={{minWidth: 350}}
            adornment={
                <CancelIcon
                    width={10}
                    height={10}
                    source={ClearIcon}
                    onClick={() => setValue('')}
                />
            }
        />
    );
};
